import * as constants from '../constants';

const initialState = {
    data: [],
    item: {}
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getPesticideGroup.success: {
            return {
                ...state, data: action.payload.results
            };
        }

        case constants.getPesticideGroupItem.success: {
            return {
                ...state, item: { ...action.payload }
            };
        }

        default:
            return state;
    }
}
